import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import './SiteView.css'

const API_BASE = 'https://backend.alephmedia.ro/api'

const DEFAULT_SITE = {
  id: null,
  name: 'Site',
  url: '',
  api_url: '',
  image_16_9: null,
  image_9_16: null,
  links: []
}

const stripHtml = (value) => {
  if (!value) return ''
  return value.replace(/<[^>]*>/g, '').trim()
}

const decodeHtmlEntities = (text) => {
  if (!text) return ''
  
  // Creează un element temporar pentru a decodifica entitățile HTML
  const textarea = document.createElement('textarea')
  textarea.innerHTML = text
  return textarea.value
}

const SOCIAL_ICONS = {
  instagram: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  ),
  youtube: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  ),
  twitter: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
    </svg>
  ),
  tiktok: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  ),
  website: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <line x1="2" y1="12" x2="22" y2="12"/>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
  )
}

function getSocialIcon(label = '') {
  const lowerLabel = label.toLowerCase()
  for (const key in SOCIAL_ICONS) {
    if (lowerLabel.includes(key)) {
      return SOCIAL_ICONS[key]
    }
  }
  return SOCIAL_ICONS.website
}

function buildPostEndpoints(apiUrl = '', fallbackUrl = '') {
  const sanitized = apiUrl.replace(/\/$/, '')
  const baseCandidates = new Set()
  if (sanitized) {
    baseCandidates.add(sanitized)
    if (sanitized.includes('wp-rest')) {
      baseCandidates.add(sanitized.replace('wp-rest', 'wp-json'))
    }
    if (sanitized.includes('wp-json')) {
      baseCandidates.add(sanitized.replace('wp-json', 'wp-rest'))
    }
  }
  if (fallbackUrl) {
    try {
      const fallbackBase = new URL('/wp-json', fallbackUrl).toString().replace(/\/$/, '')
      baseCandidates.add(fallbackBase)
    } catch (e) {
      // ignore invalid url
    }
  }

  return Array.from(baseCandidates).map((base) => `${base}/wp/v2/posts?per_page=5&_fields=id,title,link`)
}

const SiteView = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [site, setSite] = useState(DEFAULT_SITE)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [articles, setArticles] = useState([])
  const [articlesLoading, setArticlesLoading] = useState(false)
  const [articlesError, setArticlesError] = useState(null)

  useEffect(() => {
    if (!id) {
      navigate('/v3.0')
    }
  }, [id, navigate])

  useEffect(() => {
    // Întotdeauna facem fetch la API pentru a obține datele complete (inclusiv api_url și url)
    // Chiar dacă avem site-ul în state, datele din catalog nu conțin toate câmpurile necesare
    async function loadSite() {
      if (!id) return
      setLoading(true)
      setError(null)
      
      // Dacă avem site-ul în state, îl folosim temporar pentru a afișa datele de bază
      const stateSite = location.state?.site
      if (stateSite) {
        const normalizedSite = {
          ...DEFAULT_SITE,
          id: stateSite.v3_id || stateSite.id,
          name: stateSite.v3_name || stateSite.name,
          image_16_9: stateSite.v3_image_16_9 || stateSite.image_16_9,
          image_9_16: stateSite.v3_image_9_16 || stateSite.image_9_16,
          links: stateSite.v3_links || stateSite.links || [],
        }
        setSite(normalizedSite)
        // Nu setăm loading = false aici, continuăm să facem fetch pentru datele complete
      }
      
      try {
        const response = await fetch(`${API_BASE}/sites/${id}`)
        if (!response.ok) {
          throw new Error(`Nu am putut încărca site-ul. Cod: ${response.status}`)
        }
        const json = await response.json()
        if (!json.success || !json.data) {
          throw new Error('Răspuns invalid de la server.')
        }
        setSite({ ...DEFAULT_SITE, ...json.data })
      } catch (err) {
        setError(err.message || 'Nu am putut încărca site-ul selectat.')
      } finally {
        setLoading(false)
      }
    }

    loadSite()
  }, [id, location.state])

  useEffect(() => {
    if (!site.api_url) {
      setArticles([])
      setArticlesLoading(false)
      return
    }

    const controller = new AbortController()

    async function fetchTopArticles() {
      setArticlesLoading(true)
      setArticlesError(null)
      const endpoints = buildPostEndpoints(site.api_url, site.url)
      
      if (!endpoints.length) {
        setArticles([])
        setArticlesLoading(false)
        return
      }

      for (const endpoint of endpoints) {
        try {
          const response = await fetch(endpoint, {
            signal: controller.signal,
            headers: {
              Accept: 'application/json'
            }
          })
          
          if (!response.ok) {
            throw new Error(`(${response.status}) ${response.statusText}`)
          }
          const data = await response.json()
          
          if (!Array.isArray(data) || !data.length) {
            continue
          }
          const normalized = data.map((post) => ({
            id: post.id,
            title: stripHtml(post?.title?.rendered || post?.title || 'Articol'),
            link: post.link || site.url
          }))
          setArticles(normalized)
          setArticlesLoading(false)
          return
        } catch (err) {
          if (err.name === 'AbortError') {
            return
          }
        }
      }

      setArticlesError('Nu am putut încărca articolele populare. Te rugăm să încerci mai târziu.')
      setArticles([])
      setArticlesLoading(false)
    }

    fetchTopArticles()

    return () => {
      controller.abort()
    }
  }, [site.api_url, site.url])

  const desktopImage = useMemo(() => site.image_16_9 || site.image_9_16, [site.image_16_9, site.image_9_16])
  const mobileImage = useMemo(() => site.image_9_16 || site.image_16_9 || null, [site.image_9_16, site.image_16_9])
  const externalUrl = site.url
  const siteLinks = site.links || []

  const domain = useMemo(() => {
    if (!externalUrl) return ''
    try {
      return new URL(externalUrl).hostname
    } catch (e) {
      return externalUrl
    }
  }, [externalUrl])

  return (
    <div className="site-view-root">
      <div className="site-view-header">
        <button type="button" className="site-view-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3333 21.6667L3 12.3333M3 12.3333L12.3333 3M3 12.3333H28.6667C31.142 12.3333 33.516 13.3167 35.2663 15.067C37.0167 16.8173 38 19.1913 38 21.6667C38 24.142 37.0167 26.516 35.2663 28.2663C33.516 30.0167 31.142 31 28.6667 31H26.3333" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      {loading && <div className="site-view-status">Se încarcă site-ul...</div>}
      {error && <div className="site-view-status site-view-status-error">{error}</div>}

      {!loading && !error && (
        <div className="site-view-content">
          <div className="site-view-hero">
            <div className="site-view-logo">
              <picture>
                <source media="(max-width: 768px)" srcSet={mobileImage || desktopImage || undefined} />
                {desktopImage ? (
                  <img src={desktopImage} alt={site.name || 'Site'} />
                ) : (
                  <div className="site-view-placeholder">{site.name?.[0] ?? '?'}</div>
                )}
              </picture>
            </div>
            {!externalUrl && <h1>{decodeHtmlEntities(site.name)}</h1>}
          </div>

          {!!siteLinks.length && (
            <div className="site-view-links">
              {/* Buton pentru site-ul principal - lat cât toate cele trei coloane */}
              {externalUrl && (
                <a href={externalUrl} target="_blank" rel="noopener noreferrer" className="site-view-link-card site-view-main-site">
                  <span className="site-view-link-icon">{SOCIAL_ICONS.website}</span>
                  <span className="site-view-link-label">Vizitează site-ul {domain}</span>
                </a>
              )}
              
              {/* Butoanele de social media */}
              {siteLinks.map((link, linkIndex) => {
                const icon = getSocialIcon(link.label || '')
                return (
                  <a key={`${link.url}-${linkIndex}`} href={link.url} target="_blank" rel="noopener noreferrer" className="site-view-link-card">
                    {icon ? <span className="site-view-link-icon">{icon}</span> : null}
                    <span className="site-view-link-label">{link.label}</span>
                  </a>
                )
              })}
            </div>
          )}

          <div className="site-view-articles">
            <h2>Cele mai citite articole</h2>
            {articlesLoading && <p className="site-view-articles-status">Se încarcă articole...</p>}
            {articlesError && <p className="site-view-articles-status site-view-articles-status-error">{articlesError}</p>}
            {!articlesLoading && !articlesError && (
              <ul>
                {(articles.length ? articles : [{ id: 'placeholder', title: 'Nu am găsit articole.' }]).map((article, index) => (
                  <li key={article.id ?? `article-${index}`}>
                    {article.link ? (
                      <a href={article.link} target="_blank" rel="noopener noreferrer" className="site-view-article-title">
                        {decodeHtmlEntities(article.title)}
                      </a>
                    ) : (
                      <span className="site-view-article-title">{decodeHtmlEntities(article.title)}</span>
                    )}
                    <span className="site-view-article-meta">
                      <span />
                      <span />
                      <span />
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default SiteView
